import { FC, MouseEvent, MouseEventHandler, useCallback } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import { Link } from 'routes';

import styles from './VerticalButton.module.scss';

interface Props {
  className?: string;
  isDisabled?: boolean;
  itemId: string;
  label: string;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  selected?: boolean;
  testId?: string;
}

const VerticalButton: FC<Props> = ({
  className = '',
  itemId,
  label = '',
  onClick,
  selected = false,
}) => {
  const router = useRouter();
  const { asPath: url } = router;
  const handleOnClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      onClick(event);
    },
    [onClick]
  );

  return (
    <Link prefetch={false} route={`${url}/${itemId}`}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <a onClick={handleOnClick}>
        <div
          className={classNames(
            ...`${className} ${
              selected ? 'z-vertical-button-selected' : 'z-vertical-button-unselected'
            }`
              .split(' ')
              // Only apply CSS module for z-vertical-button classes
              .map((cssClass) =>
                cssClass.startsWith('z-vertical-button') ? styles[cssClass] : cssClass
              )
          )}
        >
          <span className={styles['z-vertical-button-label']}>
            {selected ? <h2>{label}</h2> : label}
          </span>
        </div>
      </a>
    </Link>
  );
};

export default VerticalButton;
export type { Props as VerticalButtonProps };
